import {Directive, Input} from '@angular/core';

/**
 * The NgbCollapse directive provides a simple way to hide and show an element with animations.
 */

export class NgbCollapse {
  /**
   * A flag indicating collapsed (true) or open (false) state.
   */
   collapsed = false;
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngbCollapse]',
  exportAs: 'ngbCollapse',
  host: {'[class.collapse]': 'true', '[class.in]': '!collapsed', '[attr.aria-expanded]': '!collapsed'}
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'collapsed': [{ type: Input, args: ['ngbCollapse', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
